var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgLogoOpendefi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191,
    height: 54,
    viewBox: "0 0 191 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_416",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 8,
    width: 145,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.309 8H24V45.0671H168.309V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4051 14.4074C28.6282 14.1264 28.8791 13.8454 29.13 13.5644C29.13 13.5644 29.1579 13.5363 29.1858 13.5363C29.2136 13.5081 29.2415 13.48 29.2694 13.4519L29.2973 13.4238C29.4646 13.2552 29.6318 13.0866 29.8549 12.9461C30.5798 12.3841 31.3604 11.9625 32.1411 11.6815C34.7061 10.7822 37.5778 11.3443 39.8082 13.48C42.9029 16.4308 42.6241 21.2082 40.1148 24.3557C36.9644 29.105 31.5277 35.681 39.0554 41.5825C40.3937 42.6504 41.3973 43.5216 45.663 44.758C42.875 45.2639 40.31 45.1234 37.4105 44.3646C35.3752 43.2124 32.1689 40.7394 31.0816 37.3952C29.4367 32.3368 33.9812 24.7491 36.1559 21.8265C39.1669 17.7797 34.2879 13.3957 30.7192 18.2856C28.8791 20.8429 25.5892 28.0371 26.7323 33.3766C27.4014 36.4116 28.2936 38.6036 31.8065 41.6387C31.1653 41.2452 30.524 40.7956 29.9106 40.3178C21.7138 32.6459 22.6618 20.7867 28.4051 14.4074Z",
    fill: "url(#paint0_linear_2_416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2576 38.6598C56.0345 38.9408 55.7836 39.2219 55.5326 39.5029C55.5326 39.5029 55.5048 39.531 55.4769 39.531C55.449 39.5591 55.4211 39.5872 55.3932 39.6153L55.3654 39.6434C55.198 39.812 55.0308 39.9806 54.8077 40.1211C54.0829 40.6832 53.3022 41.1047 52.5216 41.3857C49.9566 42.285 47.0849 41.723 44.8545 39.5872C41.7319 36.6364 42.0107 31.859 44.492 28.6834C47.6425 23.9622 53.0792 17.3581 45.5515 11.4566C44.2411 10.4169 43.2374 9.54568 38.9717 8.30917C41.7598 7.80333 44.3248 7.94384 47.2243 8.70261C49.2596 9.85481 52.4658 12.3278 53.5532 15.672C55.198 20.7304 50.6535 28.3181 48.4789 31.2408C45.4678 35.2875 50.3469 39.6715 53.9156 34.7817C55.7836 32.2243 59.0734 25.0301 57.9303 19.6906C57.2612 16.6556 56.369 14.4636 52.8561 11.4285C53.4973 11.822 54.1386 12.2716 54.752 12.7494C62.9209 20.4213 61.973 32.2805 56.2576 38.6598Z",
    fill: "url(#paint1_linear_2_416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.382 21.5454C67.382 17.3581 70.0863 14.295 73.9617 14.295C77.7813 14.295 80.5415 17.3581 80.5415 21.5454C80.5415 25.7327 77.8092 28.7958 73.9617 28.7958C70.1142 28.7958 67.382 25.7327 67.382 21.5454ZM78.1995 21.5454C78.1995 18.6508 76.5267 16.487 73.9338 16.487C71.3409 16.487 69.6681 18.6508 69.6681 21.5454C69.6681 24.4118 71.3131 26.6038 73.9338 26.6038C76.5267 26.6038 78.1995 24.4118 78.1995 21.5454Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.385 28.5429V14.5198H89.0447C91.7492 14.5198 93.2268 16.5151 93.2268 18.9038C93.2268 21.2645 91.7213 23.2597 89.0447 23.2597H85.6434V26.0418C85.6434 27.447 84.6397 28.5429 83.385 28.5429ZM90.9127 18.9319C90.9127 17.583 90.0206 16.7118 88.7381 16.7118H85.6434V21.152H88.7381C90.0206 21.1239 90.9127 20.2527 90.9127 18.9319Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4053 28.5429V14.5198H105.216C105.216 15.7282 104.323 16.6837 103.236 16.6837H98.6636V20.2808H105.076V22.4448H98.6636V26.3509H105.216V28.5148H96.4053V28.5429Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.124 28.5429L111.433 18.5385V28.5429H109.174V14.5198H111.489L118.068 24.2152V14.5198C119.323 14.5198 120.327 15.6158 120.327 16.9648V28.5148H118.124V28.5429Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.799 28.5429V14.5198H132.566C136.581 14.5198 139.285 17.4144 139.285 21.5173C139.285 25.6484 136.581 28.5429 132.594 28.5429H127.799ZM136.971 21.5173C136.971 18.8195 135.438 16.6837 132.594 16.6837H130.057V26.3509H132.566C135.354 26.3791 136.971 24.1871 136.971 21.5173Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.599 28.5429V14.5198H148.403C149.49 14.5198 150.381 15.4753 150.381 16.6837H143.83V20.2808H150.243V22.4448H143.83V26.3509H150.381V28.5148H141.599V28.5429Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.146 28.5429V14.5198H160.948C162.036 14.5198 162.928 15.4753 162.928 16.6837H156.376V20.2808H162.788V22.4448H156.376V28.5148H154.146V28.5429Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.05 28.5429V16.9928C166.05 15.6439 167.054 14.5479 168.309 14.5479V28.5429H166.05Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8481 41.0204V34.3601H84.3332C84.8908 34.3601 85.3648 34.8098 85.3648 35.3999H81.9913V37.1141H85.2811V38.1539H81.9913V41.0204H80.8481Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5116 37.6762C87.5116 35.681 88.9056 34.2477 90.8851 34.2477C92.8646 34.2477 94.2586 35.7091 94.2586 37.6762C94.2586 39.6715 92.8646 41.1047 90.8851 41.1047C88.9056 41.1328 87.5116 39.6715 87.5116 37.6762ZM93.0598 37.6762C93.0598 36.2992 92.1955 35.2875 90.8851 35.2875C89.5468 35.2875 88.7104 36.2992 88.7104 37.6762C88.7104 39.0532 89.5747 40.0649 90.8851 40.0649C92.2233 40.093 93.0598 39.0532 93.0598 37.6762Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7399 38.3788V35.5404C96.7399 34.894 97.2696 34.3601 97.9108 34.3601V38.3507C97.9108 39.4186 98.4964 40.093 99.5837 40.093C100.671 40.093 101.257 39.4186 101.257 38.3507V34.3601C101.898 34.3601 102.427 34.894 102.427 35.5404V38.3788C102.427 40.0088 101.479 41.1328 99.5837 41.1328C97.6879 41.1328 96.7399 40.0088 96.7399 38.3788Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.844 41.0204L106.415 36.2711V41.0204H105.271V34.3601H106.47L109.844 38.969V34.3601C110.485 34.3601 110.987 34.894 110.987 35.5123V40.9923H109.844V41.0204Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.719 41.0204V34.3601H116.173C118.236 34.3601 119.63 35.7372 119.63 37.6762C119.63 39.6434 118.236 40.9923 116.2 40.9923H113.719V41.0204ZM118.459 37.6762C118.459 36.4116 117.678 35.3718 116.2 35.3718H114.89V39.9525H116.173C117.623 39.9806 118.459 38.9408 118.459 37.6762Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.405 41.0204L125.93 39.7277H122.92L122.445 41.0204H121.135L123.728 34.3883H125.178L127.771 41.0204H126.405ZM124.397 35.5404L123.198 38.7161H125.568L124.397 35.5404Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.754 41.0204V35.3999H128.747C128.914 34.7817 129.471 34.3883 130.085 34.3883H133.904V35.3999H131.897V41.0204H130.754Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.246 41.0204V34.3601C136.888 34.3601 137.39 34.894 137.39 35.5123V40.9923H136.246V41.0204Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.899 37.6762C139.899 35.681 141.293 34.2477 143.272 34.2477C145.252 34.2477 146.645 35.7091 146.645 37.6762C146.645 39.6715 145.252 41.1047 143.272 41.1047C141.293 41.1328 139.899 39.6715 139.899 37.6762ZM145.446 37.6762C145.446 36.2992 144.583 35.2875 143.272 35.2875C141.934 35.2875 141.097 36.2992 141.097 37.6762C141.097 39.0532 141.934 40.0649 143.272 40.0649C144.611 40.093 145.446 39.0532 145.446 37.6762Z",
    fill: "#14151A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.727 41.0204L150.298 36.243V40.9923H149.155V34.3601H150.354L153.727 38.969V34.3601C154.368 34.3601 154.87 34.894 154.87 35.5123V40.9923H153.727V41.0204Z",
    fill: "#14151A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_416",
    x1: 23.9349,
    y1: 28.1668,
    x2: 60.7068,
    y2: 28.1668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_416",
    x1: 23.9349,
    y1: 24.8982,
    x2: 60.7068,
    y2: 24.8982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30C258"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoOpendefi);
export default __webpack_public_path__ + "static/media/img-logo-opendefi.97b616c88eab5fecbf4abcbd1262981f.svg";
export { ForwardRef as ReactComponent };